<template>
    <div id="wrapper" :key="valuekey">
        <div class="content-page">
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="page-title-box">
                                <h4 class="page-title">{{$t('string.msg.product.group.label.title')}}</h4>

                            </div>
                        </div>
                    </div>
                    <!-- Form row -->
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card-box">
                                <p class="sub-header">
                                    {{$t('string.msg.product.group.label.decription')}}
                                </p>

                                <form>
                                    <div v-if="data._id" class="form-group col-md-6">
                                        <label for="inputAddress" class="col-form-label">
                                            <code class="highlighter-rouge">*</code>
                                            {{$t('string.msg.product.group.label.id')}}
                                        </label>
                                        <input type="text" readonly v-model="data._id" class="form-control">
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                <code class="highlighter-rouge">*</code>
                                                {{$t('string.msg.product.group.label.name')}}
                                            </label>
                                            <input type="text" v-model="data.name" class="form-control" :placeholder="$t('string.msg.product.group.placeholder.name')">
                                        </div>

                                        <div class="form-group col-md-6">
                                            <label for="inputAddress" class="col-form-label">
                                                <code class="highlighter-rouge">*</code>
                                                {{$t('string.msg.product.group.label.status')}}
                                            </label>
                                            <select v-model="data.status" class="form-control">
                                                <option value="ACTIVE" selected>{{$t('string.msg.status.ACTIVE')}}</option>
                                                <option value="ARCHIVED">{{$t('string.msg.status.ARCHIVED')}}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <br/>
                                    <div class="d-flex justify-content-between bd-highlight mb-3">
                                        <button @click="clearForm" class="btn btn-secondary w-20">{{$t('string.msg.form.btn.clear')}}</button>
                                        <button @click="save" class="btn btn-danger w-20">{{$t('string.msg.form.btn.save')}}</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>

                    <List v-on:load-item="selectItem"/>
                    
                </div>
            </div>
        </div>
        
        <Spinner />
        <Toast :title="titleToast" :message="messageToast" :messageId="messageIdToast" />
    </div>
</template>

<script>
import Controller from './CrtGroup';

import Spinner from '../../../components/layout/Spinner';
import Toast from '../../../components/layout/Toast';

import List from './ListGroups';

export default {
  name: 'Groups',
  components: {
    Spinner,
    Toast,
    List
  },
  data() {
      return {
        errors: [],
        valuekey: 0,
        titleToast: null,
        messageToast: null,
        messageIdToast: null,
        data: {
            status: "ACTIVE",
            name: null
        }
      }
  },
  methods: Controller.methods,
  created() {
    Controller.init(this);
  },
  mounted(){
  }
}
</script>

<style>
</style>
